import { Box, Typography } from '@mui/material';
import React from 'react';
import { useWatch } from 'react-hook-form';
import { WarningIcon } from '../../../dum';

export function TaxRequirementWarning({
    marginTop = 1,
    marginBottom = 1,
}: {
    marginTop?: number;
    marginBottom?: number;
}) {
    const [requireTax, tax] = useWatch({
        name: ['require_tax', 'tax'],
    });

    if (!requireTax || Number(tax) > 0) return null;

    return (
        <Box
            sx={{
                mt: marginTop,
                mb: marginBottom,
                px: 1,
                display: 'flex',
                alignItems: 'center',
                gap: 0.5,
            }}
        >
            <WarningIcon fontSize={'small'} color={'warning'} />
            <Typography
                variant={'body2'}
                color={'warning.main'}
                sx={{ fontWeight: 'bold' }}
            >
                IVA requerido sin registrar
            </Typography>
        </Box>
    );
}
